import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Calendar"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 3.02246H16.5V1.52246H15V3.02246H9V1.52246H7.5V3.02246H4.5C3.67157 3.02246 3 3.69403 3 4.52246V19.5225C3 20.3509 3.67157 21.0225 4.5 21.0225H19.5C20.3284 21.0225 21 20.3509 21 19.5225V4.52246C21 3.69403 20.3284 3.02246 19.5 3.02246ZM19.5 19.5225H4.5V9.02246H19.5V19.5225ZM19.5 7.52246H4.5V4.52246H7.5V6.02246H9V4.52246H15V6.02246H16.5V4.52246H19.5V7.52246Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Calendar.vue"]]);
